import React from 'react';
import { I18n } from 'react-redux-i18n-lite';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as accountActions from '../../actions/accountActions';
import * as messageAlert from '../../actions/messageAlertAction';
import { LoginGoogleButton } from './LoginGoogle.button';
import { smartLoaderService } from '../../services/domain/smartLoaderService';
import { redirect } from '../../utils/HttpUtils';

/**/

class LoginGoogle extends React.Component {
  constructor(props) {
    super(props);

    this.successGoogle = this.successGoogle.bind(this);
    this.errorGoogle = this.errorGoogle.bind(this);
  }

  successGoogle(response) {
    const { isAppOnline, redirectAfterLogin } = this.props;
    if (isAppOnline) {
      // depending on origin (LoginGoogleWeb or LoginGoogleElectron), profile info is stored in a different structure
      let profile = response.profileObj || response;
      // access token comes always as first level property
      let accessToken = response.accessToken;

      let data = {
        email: profile.email,
        name: profile.given_name,
        surname: profile.family_name,
        picture: profile.picture,
        accessToken: accessToken
      };

      const { accountActions } = this.props;
      smartLoaderService.open();
      accountActions
        .loginGoogle(data)
        .then(() => {
          redirect(window.location.origin + redirectAfterLogin).then(() => {
            accountActions.clearRedirectAfterLogin();
            smartLoaderService.close();
          });
        })
        .catch(() => {
          smartLoaderService.close();
        });
    }
  }

  errorGoogle(error) {
    if (error.error !== 'popup_closed_by_user') {
      let { messageAlert } = this.props;
      messageAlert.error(I18n.t('login.error'));
    }
  }

  render() {
    return (
      <div>
        <LoginGoogleButton onSuccess={this.successGoogle} onFailure={this.errorGoogle} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    redirectAfterLogin: state.router.redirectAfterLogin,
    isAppOnline: state.connection.status.online
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginGoogle);
